import {isMaxUser} from "../utils";

export const getSelectedUom = (product) => {
        let selectedUnit = null;

        uomRadioButtons(product).forEach(unit => {
            if (unit.checked) {
                selectedUnit = unit.value;
            }
        });

        return isMaxUser(window) ? selectedUnit : "ONE";
};

const uomRadioButtons = (product) => {
    return product.querySelectorAll(`.product-tile__switch-group--unit .product-tile__unit-switch-radio`);
};


// WEBPACK FOOTER //
// ./javascript/product-search-page/add-to-cart/uom.js